<template>
  <div class="container">
    <h1>Terms and Conditions</h1>
    <div class="publication-dates">
      <p>Published: May 01, 2018</p>
      <p>Last edition: Dec 26, 2022</p>
    </div>
    <div class="preamble">
      Please read these terms and conditions ("T&amp;C") before pressing the
      "I&nbsp;agree" button at the bottom. By pressing "I&nbsp;agree" you are
      agreeing to be bound by the terms and conditions of this agreement. If you
      do not agree to the terms and conditions of this agreement, close the tab
      and you will be unable to participate on the traforama's website.
    </div>
    <div class="intro">
      <strong>Zumaleto OU (“DSP“, “Traforama”)</strong> is a company
      incorporated and registered in Estonia, having its registered address at
      Harju maakond, Tallinn, Kesklinna linnaosa, Vesivarava tn 50-201, 10152,
      Estonia.
    </div>
    <div class="definitions">
      <p>
        The DSP is the owner of the Software allowing to purchase Traffic
        Services;
      </p>
      <p>
        The Advertiser receives the Web Traffic through Feeds, in accordance
        with Open RTB Protocol or through Direct Campaigns;
      </p>
      <p>
        The Advertiser examined entirely and comprehensively the substance of
        the Software and became satisfied with its quality, taking into account
        that the Software is provided under the condition “as is”;
      </p>
      <p>
        The Advertiser is responsible for paying DSP for Traffic Services
        generated by DSP based on DSP reports. DSP will provide the aggregated
        reports of the Traffic Services cost on a daily basis on the Official
        Website to the Advertiser. The reports will reflect the total spend and
        ad impressions count from DSP’s data-tracking system.
      </p>
    </div>

    <h2>1. Definitions</h2>
    <div>
      <strong>1.1. The Official Website</strong> is the website on the Internet
      where the Software is published, namely:
      <a href="https://www.traforama.com/" target="_blank" rel="noreferrer"
        >https://www.traforama.com/</a
      >
    </div>
    <div>
      <strong>1.2. The Software</strong> is the technology, that allows
      delivering the Web Traffic to the Advertiser on a CPM, or CPC basis
      depending on how it is established in this Agreement and provides other
      functionality in the field of real-time advertisement bidding.
    </div>
    <div>
      <strong>1.3. Traffic Services</strong> is the services provided by the DSP
      through the Software, consisting in the delivery of the Web Traffic to the
      Advertiser on a CPM or CPC basis depending on how it is established in
      this Agreement, namely, placement the advertisements on the third parties
      websites.
    </div>
    <div>
      <strong>1.4. The Publisher</strong> is any third party that is owned
      and/or operated websites, applications, or other content sources where the
      DSP intends to place Advertiser Promotion Materials through Feeds, in
      accordance with Open RTB Protocol or through Direct Campaigns.
    </div>
    <div>
      <strong>1.5. Feed</strong> is a special URL provided by the Advertiser to
      be set up on the Software independently by the DSP in order to be able to
      provide the Traffic Services.
    </div>
    <div>
      <strong>1.6. Open RTB Protocol</strong> - rules of implementation of
      automated trade with the Web Traffic, at the time of signing the Agreement
      described in the document
      <a
        href="https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf"
        target="_blank"
        rel="noreferrer"
        >https://www.iab.com/wp-content/uploads/2016/03/OpenRTB-API-Specification-Version-2-5-FINAL.pdf</a
      >
    </div>
    <div>
      <strong>1.7. Direct Campaign</strong> is a specific entity in the Software
      interface where the Advertiser may place the Promotion Materials in order
      DSP to provide the Traffic Services.
    </div>
    <div>
      <strong>1.8. The DSP Reporting System</strong> is the API reporting URL
      and the Software interface provided by the DSP that shows real-time
      statistics for clicks and/or impressions and, therefore, reflects the
      Advertisers’ spending.
    </div>
    <div>
      <strong>1.9. Personal Data</strong> means any information that,
      individually or in combination, does or can identify a specific individual
      or by or from which a specific individual may be identified or contacted.
      Personal Data is defined under the applicable law.
    </div>
    <div>
      <strong>1.10. Web traffic</strong> means any in-page push traffic, popup
      traffic, interstitial, video traffic, display traffic, and other types of
      web traffic which are delivered through the Software.
    </div>
    <div>
      <strong>1.11. Promotion Materials</strong> means the text, graphics,
      logos, designs, trademarks, landing page URLs, hyperlinks, and videos for
      any type of advertising including, but not limited to in-page push
      traffic, popup traffic, interstitial, video traffic, display traffic
      implemented by the Advertiser to the Software.
    </div>
    <div>
      <strong>1.12. The Advertiser Account</strong> means a personal account on
      the Official Website that was created by the Advertiser. The Advertiser
      must complete registration by confirming email and providing accurate
      personal data.
    </div>

    <h2>2. Services Provision</h2>
    <div>
      <strong>2.1.</strong> Services Period. The DSP agrees to provide The
      Traffic Services during the term of this Agreement. Each Party may suspend
      the Traffic Services provision upon written notice sent to the other party
      48 hours before such suspension.
    </div>
    <div>
      <strong>2.2.</strong> The Services are provided via Feed, Open RTB
      Protocol, or Direct Campaign.
    </div>
    <div><strong>2.3.</strong> Setups</div>
    <div>
      2.3.1. Feed setup (for the case of providing the Services via feed). The
      Advertiser acknowledges and agrees that it should set up Feed in order to
      be able to receive the Traffic Services. The Advertiser bears full
      responsibility for the Feed setup. In case the bid request or/and bid
      response fields are incorrectly set up by the Advertiser (e.g., Advertiser
      mixed the field responsible for delivering clicks from the DSP and used an
      incorrect filed from the bid response to receive clicks/impressions from
      the DSP) or the Advertiser made other mistakes while carrying out Feed
      setup, the DSP reserves the right charge for all Web Traffic sent within
      the Traffic Services that is reflected in the DSP’ Reporting System.
    </div>
    <div>
      2.3.2. Open RTB Protocol setup (for the case of providing the Services via
      Open RTB Protocol). The Advertiser acknowledges and agrees that for
      provision of the Services via Open RTB Protocol setup in accordance with
      the rules of the Protocol is required. The Advertiser bears full
      responsibility for set up in accordance with Open RTB Protocol rules. In
      case the Advertiser makes some mistakes in setting up in accordance with
      Open RTB Protocol rules the DSP reserves the right to charge for all Web
      Traffic sent within the Traffic Services that is reflected in the DSP’
      Reporting System.
    </div>
    <div>
      2.3.3. Direct Campaign setup (for the case of providing the Services via
      Direct Campaign). The Advertiser acknowledges and agrees that it should
      set up the Direct Campaign in order to be able to receive the Traffic
      Services. The Advertiser bears full responsibility for the Direct Campaign
      setup. In case any field is incorrectly set up by the Advertiser (e.g.,
      landing page URLs, hyperlinks don't work ) or the Advertiser made other
      mistakes while carrying out Direct Campaign setup, the DSP reserves the
      right charge for all Web Traffic sent within the Traffic Services that is
      reflected in the DSP’ Reporting System.
    </div>
    <div><strong>2.4.</strong> Advertising Management</div>
    <div>
      2.4.1. The Advertiser may manage Feeds and/or Direct Campaigns through the
      Official Website by setting budgets, targeting filters, and all other
      information relevant to Feeds and Direct Campaigns.
    </div>
    <div>
      2.4.2. The Advertiser expressly agrees to any changes to Feed or Direct
      Campaign settings that are made through the Official Website, LiveChat, or
      by email.
    </div>
    <div>
      2.4.3. If problems arise with the performance of the Feed and/or Direct
      Campaign, the Advertiser may with at least three (3) business days’
      notice, request the Feed and/or Direct Campaign to be temporarily
      suspended to allow the parties to resolve and repair any possible issues.
    </div>
    <div>
      <strong>2.5.</strong> The Promotional Materials verification. The
      Advertiser undertakes to check all Promotional Materials provided to the
      Software and urgently remove it, in case of suspected inappropriate
      content. Inappropriate content includes but is not limited to:
      <ul>
        <li>Exploitation and sexualization of minors;</li>
        <li>
          High-risk investments, rapid enrichment schemes, and financial
          pyramids;
        </li>
        <li>Promoting illegal activities;</li>
        <li>Drugs, digital drugs;</li>
        <li>Knowingly false information;</li>
        <li>Weapons and explosives;</li>
        <li>
          A call to join religious groups and participate in religious
          ceremonies;
        </li>
        <li>Intentional self-harm, mutilation, suicide propaganda;</li>
        <li>The spread of the illicit trade in human organs;</li>
        <li>Escort services;</li>
        <li>Goods and services against human rights and freedoms;</li>
        <li>
          Publications containing hostile statements or attacks on an
          individual, or organization based on;
        </li>
        <li>
          Publications containing a direct or hidden context of threat,
          harassment, and violence;
        </li>
        <li>Hate speech, criminal or terrorist-related content;</li>
        <li>
          Mentioning of events or customs that cause harm to a person in a
          degrading, unfriendly, or offensive manner;
        </li>
        <li>Content related to hacking into computer systems, and programs;</li>
        <li>Fake tech support services;</li>
        <li>
          Pages that include browser/tab lockers, hidden redirects, or parent
          page redirects;
        </li>
        <li>Any other illegal goods, services, or transactions.</li>
      </ul>
    </div>
    <div>
      <strong>2.6.</strong> The Advertiser is the owner or is licensed to use
      the Advertising Materials.
    </div>
    <div>
      <strong>2.7.</strong> The DSP reserves the right to suspend or deactivate
      the Advertiser Account if there is a reason to believe or suspect that the
      Advertiser is in breach of this Agreement or other legal obligation
      (including fraudulent activity or in case if the Promotional Materials may
      include inappropriate content or misleading advertising) without prior
      notice or liability.
    </div>
    <div>
      <strong>2.8.</strong> The DSP responsibility. The DSP is not responsible
      for the quality of the delivered traffic. The DSP undertakes to provide to
      the Advertiser the full list of traffic sources and give the advertiser
      the ability to disable any suspicious traffic sources.
    </div>

    <h2>3. Payment</h2>
    <div>
      <strong>3.1.</strong> Payment terms. The DSP undertakes to credit the
      Advertiser account balance within three (3) business days after receiving
      proof of payment. The Advertiser must provide The DSP with proof of
      payment.
    </div>
    <div>
      <strong>3.2.</strong> The currencies of all settlements between the
      Parties are US Dollars, but by agreement of the parties, settlements can
      be in Euros.
    </div>
    <div>
      <strong>3.3.</strong> To converse currencies, Parties will use Exchange
      Rate of the European Central Bank on the date of the invoice:
      <a
        href="https://www.ecb.europa.eu/stats/policy_and_exchange_rates/euro_reference_exchange_rates/html/eurofxref-graph-usd.en.html"
        target="_blank"
        rel="noreferrer"
        >https://www.ecb.europa.eu/stats/policy_and_exchange_rates/euro_reference_exchange_rates/html/eurofxref-graph-usd.en.html</a
      >.
    </div>
    <div>
      <strong>3.4.</strong> The Advertiser must initially fund the balance on
      the Advertiser Account with at least $100.00 (one hundred US Dollars) to
      activate Feeds and/or Direct Campaigns. If the balance on the Official
      Website is reduced to null, the Advertiser Account shall be put on hold,
      and all Feeds and/or Direct Campaigns shall be paused until the Advertiser
      deposit further funds in Advertiser Account. As soon as a deposit is
      furthered funds in the Advertiser Account, all Feeds and/or Direct
      Campaigns previously paused due to insufficient funds shall be
      reactivated.
    </div>
    <div>
      <strong>3.5.</strong> Taxes and other fees. All payments do not include
      taxes, duties, fees, and other amounts assessed or imposed by any
      government entity or banks. The Advertiser bears all payment costs in
      connection with funds transfers.
    </div>
    <div>
      <strong>3.6.</strong> Invoicing. The invoice information form must be
      filled out before using certain payment methods. The Advertiser expressly
      accepts to be solely responsible for providing accurate personal data
      which is fully and legally compliant for the purposes of invoicing and
      taxation.
    </div>
    <div>
      <strong>3.7.</strong> Refunds. The Advertiser reserves the right to
      receive the unused amount of the paid balance if the amount exceeds 100
      U.S. dollars. The DSP undertakes refund unused funds within thirty (30)
      working days after receiving a request from the Advertiser by email to
      <a href="mailto:support@traforama.com">support@traforama.com</a>.
    </div>
    <div>
      <strong>3.8.</strong> Advertiser is responsible to provide current and
      accurate payment information, including any updates (including TAX/VAT
      number validation changes if applied).
    </div>
    <div>
      <strong>3.9.</strong> Provided payment details must belong to the owner of
      the Company and can’t belong to the third party.
    </div>

    <h2>4. Force majeure</h2>
    <div>
      <strong>4.1.</strong> The Parties are exempt from liability for partial or
      entire failure to perform their obligations under the Agreement provided
      such failure resulted from circumstances of extraordinary nature that
      occurred after the Agreement had been concluded. Such circumstances of
      extraordinary nature include exclusively the events beyond the control of
      the Party and the Party is not responsible for their emergence or is not
      able to avoid or overcome them, in particular floods, fires, earthquakes,
      volcanic eruptions, tsunami, accidents of anthropogenic nature, national
      strikes, international agreements prohibiting operations subject to
      implementation within the framework of the Agreement, actions (inactions)
      of state institutions and (or) state officials, illegal activities of
      third persons. The circumstances eliminating liability from the Party
      include governmental regulations or decrees of state institutions that
      make compliance with the obligations by the Parties impossible.
    </div>
    <div>
      <strong>4.2.</strong> The Party referring to the circumstances of an
      extraordinary nature shall inform the other Party in writing within five
      (5) days on such circumstances of extraordinary nature appearance and
      prove its emergence with official documents of the relevant chamber of
      commerce and industry or another competent institution of the relevant
      country.
    </div>
    <div>
      <strong>4.3.</strong> Provided that any of the above-mentioned in clause
      7.1 hereof circumstances directly affect fulfillment of obligations in due
      term stipulated in the Agreement the said term shall be postponed
      commensurably for the term of the relevant action validity.
    </div>

    <h2>5. Personal Data</h2>
    <div>
      <strong>5.1.</strong> Each Party shall comply with its obligations under
      all data protection laws in respect of the Services and the Software to be
      provided under this Agreement to each other.
    </div>
    <div>
      <strong>5.2.</strong> The Advertiser agrees in respect of any such
      Personal Data supplied to it by the DSP that it shall only act on
      instructions from the DSP regarding the processing of such Personal Data
      under this Agreement and shall ensure that appropriate technical and
      organizational measures shall be taken against unauthorized or unlawful
      processing of the Personal Data and against accidental loss or destruction
      of or damage to the Personal Data.
    </div>

    <h2>6. Privacy policy</h2>
    <div>
      We retain a separate Privacy Policy and your assent to these Terms also
      signifies your assent to the Privacy Policy. We reserve the right to amend
      the Privacy Policy at any time by posting such amendments to the Service.
      The top of the Privacy Policy will indicate the date that amendments were
      last made. No other notification may be made to you about any amendments,
      so periodically check the Privacy Policy for changes. Your continued use
      of the Service following such amendments will constitute your acceptance
      of such amendments, regardless of whether you have actually read them.
    </div>

    <h2>7. Disclaimer</h2>
    <div>
      We do not control or verify any content provided by publishers and
      therefore we will not accept any and hereby exclude all legal liability
      for such information or content.
    </div>
    <div>
      In no event will either party be responsible to the other party for any
      consequential, special, punitive, or other damages, including lost revenue
      or profits, arising out of or related to this agreement, even if a party
      has been advised of the possibility of such damages. In no event will
      either party’s liability to the other party exceed the total amount
      actually paid by Advertise to Traforama during the three-month period
      prior to the first date on which the liability arose.
    </div>

    <h2>8. Force majeure</h2>
    <div>
      Traforama will not be liable for failing to perform under these Terms and
      Conditions by the occurrence of any event beyond its reasonable control,
      including, without limitation, a labour disturbance, an internet outage or
      interruption of service, a communication outage, a failure by a service
      provider to Traforama to perform, fire, threatened or actual act of
      terrorism, natural disaster or war.
    </div>

    <h2>9. Confidentiality</h2>
    <div>
      Any information relating to or disclosed in the course of this agreement
      that is or should be reasonably understood to be confidential or
      proprietary to Traforama, including the terms of this agreement,
      information about Traforama, technical process, marketing guidelines,
      product designs, business plans, and marketing data, will be kept
      confidential by Advertiser. Furthermore, Advertiser specifically agrees
      not to disclose our Service rates or to provide copies of screenshots of
      any of our websites including but not limited to the Traforama's website.
    </div>
    <div>
      The Traforama’s website provides you with access to Traforama’s reports,
      creative, campaign, payment, and other information. All information and
      materials on the Traforama’s website are the proprietaries and copyrighted
      property of Traforama or its licensors.
    </div>
    <div>
      Any other use of the Traforama’s website without Traforama’s prior written
      consent is prohibited, including: (a) any resale or commercial use of the
      Traforama’s website or Information; (b) the retransmission, distribution,
      display or publication of the Information or any other materials available
      on the Traforama’s website; (c) making derivative uses of the Traforama’s
      website and Information; (d) downloading any portion of the Traforama’s
      website or any Information, except as expressly permitted on the
      Traforama’s website; or (e) any use of the Traforama’s website or
      Information other than for its intended purpose.
    </div>

    <h2>10. Term</h2>
    <div>
      This Agreement will commence when Traforama approves your registration and
      shall continue for a period of one year (the “Term”). Thereafter, this
      Agreement will automatically renew for successive one-year terms.
    </div>
    <div>
      Termination. Either party may terminate this Agreement at any time upon
      five days written notice to the other party. Traforama may immediately
      terminate this Agreement if Advertiser is in breach of any terms of this
      Agreement.
    </div>

    <h2>11. Survival</h2>
    <div>
      All provisions by their nature that are intended to survive termination or
      expiration of this agreement, including those regarding confidentiality,
      representations, indemnification, and payment of fees, will survive the
      termination or expiration of this agreement.
    </div>

    <div class="postscriptum">
      Traforama reserves the right, at its discretion, to modify these Terms at
      any time by posting a notice on the Site.
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TermsAndConditionsText'
})
</script>

<style lang="scss" scoped>
.container {
  max-height: 65vh;
  overflow-y: scroll;
  padding-right: 25px;
  margin-right: -25px;
  word-break: normal;

  & > div {
    margin-bottom: 1em;
  }
  @media only screen and (max-width: 767px) {
    height: 40vh;
  }
}

h1 {
  text-align: center;
}

.publication-dates {
  text-align: right;
  margin-bottom: 2em;
  p {
    margin: 0;
  }
}

.preamble,
.postscriptum {
  font-weight: bold;
}

.definitions {
  p {
    margin: 0;
    text-indent: 1em;
  }
}

a {
  word-break: break-all;
}
</style>
